import { createContext } from 'react';

export interface TabsContextValue {
  level: number;
}

const TabsContext = createContext<TabsContextValue>({
  level: 1
});

export default TabsContext;
